// extracted by mini-css-extract-plugin
export default {"notCompletedPanelContainer":"not-completed-panel_notCompletedPanelContainer__GNQCH","heading":"not-completed-panel_heading__sYyan","attention":"not-completed-panel_attention__-JE8D"};